import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

interface Job {
    id: number;
    title: string;
    department: string;
    location: string;
    type: string;
    description: string;
    shortDescription?: string;
    requirements: string[];
    benefits: string[];
    skills?: string[];
    salary?: string;
    postedDate: string;
    applicationDeadline?: string;
}

const jobs: Job[] = [
    // {
    //     id: 1,
    //     title: 'Développeur Full Stack',
    //     department: 'Engineering',
    //     location: 'Port-au-Prince, Haïti',
    //     type: 'Temps plein',
    //     description: 'Nous recherchons un développeur Full Stack expérimenté pour rejoindre notre équipe dynamique. Vous serez responsable de la conception et du développement de solutions web innovantes, en travaillant sur des projets passionnants qui ont un impact réel sur nos clients.',
    //     shortDescription: 'Développeur Full Stack expérimenté pour concevoir et développer des solutions web innovantes.',
    //     requirements: [
    //         '4+ ans d\'expérience en développement web',
    //         'Expertise en React, Node.js, et TypeScript',
    //         'Expérience avec les bases de données SQL et NoSQL',
    //         'Connaissance des principes DevOps',
    //         'Excellentes compétences en résolution de problèmes',
    //     ],
    //     benefits: [
    //         'Salaire compétitif',
    //         'Assurance santé',
    //         'Horaires flexibles',
    //         'Formation continue',
    //         'Équipement haut de gamme',
    //     ],
    //     skills: [
    //         'React', 'Node.js', 'TypeScript', 'MongoDB', 'PostgreSQL',
    //         'AWS', 'Docker', 'Git', 'CI/CD', 'REST APIs'
    //     ],
    //     salary: '60,000 - 80,000 USD/an',
    //     postedDate: '2025-03-15',
    //     applicationDeadline: '2025-05-15',
    // },
    // {
    //     id: 2,
    //     title: 'Designer UX/UI',
    //     department: 'Design',
    //     location: 'Port-au-Prince, Haïti',
    //     type: 'Temps plein',
    //     description: 'Nous cherchons un designer UX/UI créatif et passionné pour concevoir des expériences utilisateur exceptionnelles. Vous travaillerez en étroite collaboration avec notre équipe de développement et nos clients pour créer des interfaces intuitives et esthétiques qui répondent aux besoins des utilisateurs.',
    //     shortDescription: 'Designer UX/UI créatif pour concevoir des expériences utilisateur exceptionnelles.',
    //     requirements: [
    //         '3+ ans d\'expérience en design UX/UI',
    //         'Maîtrise de Figma et Adobe Creative Suite',
    //         'Portfolio impressionnant',
    //         'Expérience en design systems',
    //         'Connaissance des principes d\'accessibilité',
    //         'Capacité à diriger des ateliers de design thinking',
    //     ],
    //     benefits: [
    //         'Salaire compétitif',
    //         'Horaires flexibles',
    //         'Équipement haut de gamme',
    //         'Budget formation',
    //         'Événements d\'équipe mensuels',
    //     ],
    //     skills: [
    //         'Figma', 'Adobe XD', 'Sketch', 'InVision', 'Principle',
    //         'HTML/CSS', 'Design Systems', 'Prototypage', 'User Research'
    //     ],
    //     salary: '45,000 - 65,000 USD/an',
    //     postedDate: '2025-03-20',
    //     applicationDeadline: '2025-05-20',
    // },
    // {
    //     id: 3,
    //     title: 'Chef de Projet Digital',
    //     department: 'Management',
    //     location: 'Port-au-Prince, Haïti',
    //     type: 'Temps plein',
    //     description: 'En tant que Chef de Projet Digital, vous serez responsable de la gestion et de la livraison réussie des projets digitaux pour nos clients. Vous travaillerez avec des équipes multidisciplinaires pour assurer la qualité et le respect des délais de nos projets.',
    //     shortDescription: 'Chef de projet expérimenté pour gérer des projets digitaux innovants.',
    //     requirements: [
    //         '5+ ans d\'expérience en gestion de projets digitaux',
    //         'Certification PMP ou équivalent',
    //         'Excellence en communication',
    //         'Expérience avec les méthodologies Agile',
    //         'Capacité à gérer plusieurs projets simultanément',
    //     ],
    //     benefits: [
    //         'Salaire très compétitif',
    //         'Prime sur objectifs',
    //         'Assurance santé premium',
    //         'Plan d\'épargne entreprise',
    //         'Formation continue',
    //     ],
    //     skills: [
    //         'Gestion de Projet', 'Agile', 'Scrum', 'Jira',
    //         'Budgétisation', 'Risk Management', 'Stakeholder Management'
    //     ],
    //     salary: '70,000 - 90,000 USD/an',
    //     postedDate: '2025-03-25',
    //     applicationDeadline: '2025-05-25',
    // },
    // {
    //     id: 4,
    //     title: 'Spécialiste Marketing Digital',
    //     department: 'Marketing',
    //     location: 'Port-au-Prince, Haïti',
    //     type: 'Temps plein',
    //     description: 'Nous recherchons un spécialiste du marketing digital créatif et orienté données pour développer et exécuter des stratégies marketing innovantes. Vous serez responsable de la croissance de notre présence en ligne et de l\'acquisition de clients.',
    //     shortDescription: 'Spécialiste marketing digital pour développer notre présence en ligne.',
    //     requirements: [
    //         '3+ ans d\'expérience en marketing digital',
    //         'Expertise en SEO/SEM',
    //         'Maîtrise des réseaux sociaux',
    //         'Compétences analytiques avancées',
    //         'Expérience en content marketing',
    //     ],
    //     benefits: [
    //         'Salaire compétitif',
    //         'Bonus annuel',
    //         'Assurance santé',
    //         'Budget formation',
    //         'Événements d\'équipe',
    //     ],
    //     skills: [
    //         'Google Analytics', 'SEO', 'SEM', 'Social Media',
    //         'Content Strategy', 'Email Marketing', 'Data Analysis'
    //     ],
    //     salary: '45,000 - 60,000 USD/an',
    //     postedDate: '2025-03-28',
    //     applicationDeadline: '2025-05-28',
    // },
    // {
    //     id: 5,
    //     title: 'DevOps Engineer',
    //     department: 'Engineering',
    //     location: 'Port-au-Prince, Haïti',
    //     type: 'Temps plein',
    //     description: 'Nous cherchons un ingénieur DevOps expérimenté pour améliorer et maintenir notre infrastructure cloud. Vous serez responsable de l\'automatisation, de la sécurité et de la performance de nos systèmes.',
    //     shortDescription: 'Ingénieur DevOps pour gérer notre infrastructure cloud.',
    //     requirements: [
    //         '4+ ans d\'expérience en DevOps',
    //         'Expertise AWS/Azure',
    //         'Maîtrise de Docker et Kubernetes',
    //         'Expérience en CI/CD',
    //         'Connaissance approfondie de la sécurité cloud',
    //     ],
    //     benefits: [
    //         'Salaire très compétitif',
    //         'Stock options',
    //         'Assurance santé premium',
    //         'Horaires flexibles',
    //         'Budget formation illimité',
    //     ],
    //     skills: [
    //         'AWS', 'Docker', 'Kubernetes', 'Terraform',
    //         'Jenkins', 'GitLab CI', 'Python', 'Shell Scripting'
    //     ],
    //     salary: '65,000 - 85,000 USD/an',
    //     postedDate: '2025-04-01',
    //     applicationDeadline: '2025-06-01',
    // },
];

const departments = ['Tous', 'Engineering', 'Design', 'Marketing', 'Management', 'Sales'];

interface JobModalProps {
    job: Job | null;
    isOpen: boolean;
    onClose: () => void;
}

const JobModal: React.FC<JobModalProps> = ({ job, isOpen, onClose }) => {
    if (!job) return null;

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 overflow-y-auto"
                    onClick={onClose}
                >
                    <motion.div
                        initial={{ scale: 0.95, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.95, opacity: 0 }}
                        className="bg-white dark:bg-gray-800 rounded-xl shadow-xl p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto"
                        onClick={e => e.stopPropagation()}
                    >
                        <div className="flex justify-between items-center mb-6">
                            <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
                                {job.title}
                            </h3>
                            <button
                                onClick={onClose}
                                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>

                        <div className="space-y-6">
                            <div className="flex flex-wrap gap-4 text-sm text-gray-600 dark:text-gray-300">
                                <div className="flex items-center">
                                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                    {job.department}
                                </div>
                                <div className="flex items-center">
                                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                    {job.location}
                                </div>
                                <div className="flex items-center">
                                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    {job.type}
                                </div>
                                {job.salary && (
                                    <div className="flex items-center">
                                        <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        {job.salary}
                                    </div>
                                )}
                            </div>

                            <div>
                                <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Description</h4>
                                <p className="text-gray-600 dark:text-gray-300">{job.description}</p>
                            </div>

                            <div>
                                <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Prérequis</h4>
                                <ul className="list-disc list-inside space-y-1 text-gray-600 dark:text-gray-300">
                                    {job.requirements.map((req, index) => (
                                        <li key={index}>{req}</li>
                                    ))}
                                </ul>
                            </div>

                            {job.skills && (
                                <div>
                                    <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Compétences</h4>
                                    <div className="flex flex-wrap gap-2">
                                        {job.skills.map((skill, index) => (
                                            <span
                                                key={index}
                                                className="px-3 py-1 bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200 rounded-full text-sm"
                                            >
                                                {skill}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <div>
                                <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Avantages</h4>
                                <ul className="list-disc list-inside space-y-1 text-gray-600 dark:text-gray-300">
                                    {job.benefits.map((benefit, index) => (
                                        <li key={index}>{benefit}</li>
                                    ))}
                                </ul>
                            </div>

                            <div className="flex flex-wrap gap-4 text-sm text-gray-600 dark:text-gray-300 mt-4">
                                <div>
                                    <span className="font-medium">Date de publication:</span> {new Date(job.postedDate).toLocaleDateString()}
                                </div>
                                {job.applicationDeadline && (
                                    <div>
                                        <span className="font-medium">Date limite:</span> {new Date(job.applicationDeadline).toLocaleDateString()}
                                    </div>
                                )}
                            </div>

                            <div className="mt-6 flex justify-end">
                                <button
                                    onClick={onClose}
                                    className="px-4 py-2 mr-4 border border-gray-300 dark:border-gray-600 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
                                >
                                    Fermer
                                </button>
                                <a
                                    href={`mailto:careers@kolabotech.com?subject=Candidature pour le poste de ${job.title}`}
                                    className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                                >
                                    Postuler
                                </a>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

const JobCard: React.FC<{ job: Job; onClick: () => void }> = ({ job, onClick }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [ref, inView] = useInView({
        threshold: 0.1,
        triggerOnce: true,
    });

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.5 }}
            className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden"
        >
            <div className="p-6">
                <div className="flex justify-between items-start mb-4">
                    <div>
                        <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                            {job.title}
                        </h3>
                        <div className="flex flex-wrap gap-2">
                            <span className="px-3 py-1 text-sm bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 rounded-full">
                                {job.department}
                            </span>
                            <span className="px-3 py-1 text-sm bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 rounded-full">
                                {job.location}
                            </span>
                            <span className="px-3 py-1 text-sm bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200 rounded-full">
                                {job.type}
                            </span>
                        </div>
                    </div>
                    <button
                        onClick={() => setIsExpanded(!isExpanded)}
                        className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300"
                    >
                        {isExpanded ? 'Voir moins' : 'Voir plus'}
                    </button>
                </div>

                <p className="text-gray-600 dark:text-gray-300 mb-4">{job.description}</p>

                {isExpanded && (
                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: 'auto' }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <div className="mb-4">
                            <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                                Pré-requis
                            </h4>
                            <ul className="list-disc list-inside space-y-1 text-gray-600 dark:text-gray-300">
                                {job.requirements.map((req, index) => (
                                    <li key={index}>{req}</li>
                                ))}
                            </ul>
                        </div>

                        <div className="mb-4">
                            <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                                Avantages
                            </h4>
                            <ul className="list-disc list-inside space-y-1 text-gray-600 dark:text-gray-300">
                                {job.benefits.map((benefit, index) => (
                                    <li key={index}>{benefit}</li>
                                ))}
                            </ul>
                        </div>

                        <button
                            onClick={onClick}
                            className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors duration-200"
                        >
                            Voir détails
                        </button>
                    </motion.div>
                )}
            </div>
        </motion.div>
    );
};

const JobSection = () => {
    const [selectedDepartment, setSelectedDepartment] = useState('Tous');
    const [ref, inView] = useInView({
        threshold: 0.1,
        triggerOnce: true,
    });
    const [selectedJob, setSelectedJob] = useState<Job | null>(null);

    const filteredJobs = selectedDepartment === 'Tous'
        ? jobs
        : jobs.filter(job => job.department === selectedDepartment);

    return (
        <section className="py-20 bg-gray-50 dark:bg-gray-900">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    ref={ref}
                    initial={{ opacity: 0, y: 20 }}
                    animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                    transition={{ duration: 0.5 }}
                    className="text-center mb-16"
                >
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
                        Rejoignez notre équipe
                    </h2>
                    <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
                        Découvrez les opportunités passionnantes chez KolaboTech et contribuez à façonner l'avenir technologique d'Haïti
                    </p>
                </motion.div>

                <div className="flex flex-wrap justify-center gap-2 mb-12">
                    {departments.map((department) => (
                        <button
                            key={department}
                            onClick={() => setSelectedDepartment(department)}
                            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${selectedDepartment === department
                                ? 'bg-blue-600 text-white'
                                : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-blue-50 dark:hover:bg-gray-700'
                                }`}
                        >
                            {department}
                        </button>
                    ))}
                </div>

                <div className="grid gap-6">
                    {filteredJobs.map((job) => (
                        <JobCard key={job.id} job={job} onClick={() => setSelectedJob(job)} />
                    ))}
                </div>

                {filteredJobs.length === 0 && (
                    <div className="text-center py-12">
                        <p className="text-gray-600 dark:text-gray-300">
                            Aucun poste disponible dans ce département pour le moment.
                        </p>
                    </div>
                )}
            </div>

            <JobModal job={selectedJob} isOpen={!!selectedJob} onClose={() => setSelectedJob(null)} />
        </section>
    );
};

export default JobSection;